import React from 'react';
import InfoNotificationBanner from 'components/domain/meta-modules/InfoNotificationBanner';
import InformationNotificationsBanner from './InformationNotificationsBanner';
import ScrollToTopButton from './ScrollToTopButton';

export default function MetaModules(): React.ReactElement {
  return (
    <>
      <InformationNotificationsBanner />
      <InfoNotificationBanner />
      <ScrollToTopButton />
    </>
  );
}
